// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1xgLR","left":"StickyBox_left__IO0hl","right":"StickyBox_right__EJ8AH"};